
export function allBlocks() {
	return [
		'*',
		{
			// returns all top level fields, further nested fields are defined in their respective block functions
			item: [
				'*',
				block_HeroLink(),
				block_FeaturedCases(),
				block_Iconlist(),
				block_Images(),
				block_MultipleVideos(),
				block_People(),
				block_ParallaxImages(),
				block_RelatedCases(),
				block_Services(),
				block_SingleVideo(),
				block_HeroTextPicture(),
				block_AccentImageText()
			]
		}
	]
}


export function block_HeroLink() {
	return {
		image: image()
	}
}

export function block_FeaturedCases() {
	return {
		featured_cases: [
			'*',
			{
				featured_case: workLink()
			}
		]
	}
}

export function block_People() {
	return {
		people: [
			'*',
			{
				people_id: [
					'id',
					'name',
					'role',
					'email',
					'blurb',
					{
						image: image()
					}
				]
			}
		]
	}
}

export function block_ParallaxImages() {
	return {
		image_one: image(),
		image_two: image()
	}
}

export function block_Iconlist() {
	return {
		// because this is a nested M2A field, we specify on a "block" (unit) level, equivalent to allBlocks()
		list_items: [
			'*',
			{
				item: [
					'*',
					{
						video: video()
					}
				]
			}
		]
	}
}

export function block_Images() {
	return {
		images: [
			{
				image: [
					'text',
					{
						image: image()
					}
				]
			}
		],
	}
}

export function block_MultipleVideos() {
	return {
		videos: [
			{
				video: video()
			}
		]
	}
}

export function block_RelatedCases() {
	return {
		works: [
			{
				work_id: workLink()
			}
		],

		icon_video: video()
	}
}

export function block_Services() {
	return {
		services: [
			'*',
			{
				service: ['title']
			}
		]
	}
}

export function block_SingleVideo() {
	return {
		poster: image(),
		video: video()
	}
}

export function block_HeroTextPicture() {
	return {
		image: image(),
	}
}

export function block_AccentImageText() {
	return {
		image: image(),
	}
}